"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateWithEllipsis = exports.slugifyOptions = exports.slugifyInput = exports.regularToCamelCase = exports.normalizeLink = exports.hostFromUrl = exports.formatPrice = exports.formatMoney = exports.formatDateOptions = exports.formatDateOnly = exports.formatDate24Hr = exports.formatDate = exports.copyStringToClipboard = exports.centsToDollars = exports.capitalizeFirstLetters = exports.camelCaseToRegular = void 0;
var _slugify = _interopRequireDefault(require("slugify"));
var _validator = _interopRequireDefault(require("validator"));
var _camelcase = _interopRequireDefault(require("camelcase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Solution from:
 * https://stackoverflow.com/questions/4149276/javascript-camelcase-to-regular-form
 */
var camelCaseToRegular = exports.camelCaseToRegular = function camelCaseToRegular(target) {
  var toUpper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var newString = target.split(/(?=[A-Z])/g).join(' ');
  if (toUpper) newString = newString.toUpperCase();else newString = newString.toUpperCase()[0] + newString.slice(1);
  return newString;
};
var regularToCamelCase = target => (0, _camelcase.default)(target);

/**
 * Truncates the target string after 45 characters by default and appends an ellipsis
 * at the end.
 */
exports.regularToCamelCase = regularToCamelCase;
var truncateWithEllipsis = exports.truncateWithEllipsis = function truncateWithEllipsis(target) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 45;
  return target.substr(0, length) + '...';
};
var slugifyOptions = exports.slugifyOptions = {
  lower: true,
  remove: /[$*_+~.,()'"!\:@]/g
};
_slugify.default.extend({
  '|': '',
  $: '%24',
  '%': '%'
});
var slugifyInput = value => {
  return (0, _slugify.default)(value, slugifyOptions);
};
exports.slugifyInput = slugifyInput;
var formatDateOptions = exports.formatDateOptions = {
  month: 'long',
  day: '2-digit',
  year: 'numeric'
};
var formatDate = exports.formatDate = function formatDate(input) {
  var dateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : formatDateOptions;
  return new Date(input).toLocaleDateString(undefined, dateOptions);
};
var formatDate24Hr = numString => {
  var formattedDate = new Date(parseInt(numString));
  return formattedDate.toLocaleDateString('en-US', {
    hour12: true,
    hour: 'numeric',
    minute: 'numeric'
  });
};
exports.formatDate24Hr = formatDate24Hr;
var formatDateOnly = numString => {
  var formattedDate = new Date(parseInt(numString));
  return formattedDate.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};
exports.formatDateOnly = formatDateOnly;
var hostFromUrl = urlString => {
  var url = urlString;
  try {
    if (_validator.default.isURL(url)) {
      url = new URL(urlString).hostname;
      return url;
    }
  } catch (_err) {
    return urlString;
  }
  return urlString;
};

// ref: https://stackoverflow.com/a/4878800
exports.hostFromUrl = hostFromUrl;
var capitalizeFirstLetters = input => input.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
exports.capitalizeFirstLetters = capitalizeFirstLetters;
var formatPrice = price => (price / 100).toFixed(2);
exports.formatPrice = formatPrice;
var formatMoney = input => {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
  return formatter.format(input);
};
exports.formatMoney = formatMoney;
var centsToDollars = price => (price / 100).toFixed(2);

/**
 * Normalize link removes protocols and the www. prefixes and appends a '//'
 * to allow hrefs to open non-www links in a new window rather than appending them
 * to the local domain (e.g, submissions.elevatormag.com/user/test/facebook.com/test)
 */
exports.centsToDollars = centsToDollars;
var normalizeLink = exports.normalizeLink = function normalizeLink(linkRaw) {
  var addPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (addPrefix ? '//' : '') + linkRaw.replace('https://', '').replace('www.', '');
};

// https://techoverflow.net/2018/03/30/copying-strings-to-the-clipboard-using-pure-javascript/
var copyStringToClipboard = str => {
  // Create new element
  var el = document.createElement('textarea');
  // Set value (string to be copied)
  el.value = str;
  // Set non-editable to avoid focus and move outside of view
  el.setAttribute('style', "display: 'none';");
  document.body.appendChild(el);
  // Select text inside element
  el.select();
  // Copy text to clipboard
  document.execCommand('copy');
  // Remove temporary element
  document.body.removeChild(el);
};
exports.copyStringToClipboard = copyStringToClipboard;